import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=549f6148&scoped=true&lang=pug"
import script from "./Promotions.vue?vue&type=script&lang=ts"
export * from "./Promotions.vue?vue&type=script&lang=ts"
import style0 from "./Promotions.vue?vue&type=style&index=0&id=549f6148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549f6148",
  null
  
)

export default component.exports